import { useModalContext } from '../context.mjs';

function useModalFooterElement() {
  const { modalFooterElement } = useModalContext("Modal.useModalFooterElement");
  return { modalFooterElement };
}

export { useModalFooterElement };
//# sourceMappingURL=useModalFooterElement.mjs.map
